import { TRIGGER_INITIATE_PAYMENT_API_CALL, TRIGGER_INITIATE_PAYMENT_API_CALL_SUCCESS } from 'redux/actionTypes';

export function triggerInitiatePaymentApiCall(data, callback, stopLoader) {
	return {
		type: TRIGGER_INITIATE_PAYMENT_API_CALL,
		data,
		stopLoader,
		callback,
	};
}

export function triggerInitiatePaymentApiCallSuccess(data) {
	return {
		type: TRIGGER_INITIATE_PAYMENT_API_CALL_SUCCESS,
		data,
	};
}
